import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '@app/store'

const initialState = {
  uploadProgress: 0,
  recordingStatus: false,
  newRecordingFetching: false,
  tutorialVideoModalOpen: false,
}

export const globalSlice = createSlice({
  name: 'globalSlice',
  initialState,
  reducers: {
    setUploadProgress: (state, action) => {
      return {
        ...state,
        uploadProgress: action.payload,
      }
    },
    setRecordingStatus: (state, action) => {
      return {
        ...state,
        recordingStatus: action.payload,
      }
    },
    setNewRecordingFetching: (state, action) => {
      return {
        ...state,
        newRecordingFetching: action.payload,
      }
    },
    setTutorialVideoModalOpen: (state, action) => {
      return {
        ...state,
        tutorialVideoModalOpen: action.payload,
      }
    },
  },
})

export const {
  setUploadProgress,
  setRecordingStatus,
  setNewRecordingFetching,
  setTutorialVideoModalOpen,
} = globalSlice.actions
export const selectUploadProgress = (state: RootState) => state.recordings.uploadProgress
export const selectRecordingStatus = (state: RootState) => state.recordings.recordingStatus
export const selectnewRecordingFetching = (state: RootState) =>
  state.recordings.newRecordingFetching
export const selectTutorialVideoModalOpen = (state: RootState) =>
  state.recordings.tutorialVideoModalOpen
export default globalSlice.reducer
